import React, { useState, useEffect, useContext } from "react";
import Header from "./Comman/Header";
import Sidebar from "./Comman/Sidebar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { OnmaxContext } from "../OnmaxContext";

export default function UpdateName() {
    const username = localStorage.getItem("username");
    const navigate = useNavigate();
    const { toastSuccess, toastError } = useContext(OnmaxContext);

    const [data, setData] = useState({});

    const [loading, setLoading] = useState(false);

    const [newName, setNewName] = useState("");

    const getData = async () => {
        if (!username) return;
        try {
            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "user",
                submethod: "profile",
                username,
                key: process.env.REACT_APP_KEY,
            });
            if (!res.data?.error) {
                setData(res.data.data);
            }
        } catch (err) { console.error(err); }
    };

    useEffect(() => {
        getData();
    }, [username]);

    const sendOtp = async (e) => {
        e.preventDefault();
        if (!newName) return toastError("Enter new name");
        setLoading(true);
        try {
            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "user",
                submethod: "send",
                email: data.email,
                username,
                password: newName,
                key: process.env.REACT_APP_KEY,
            });
            if (res.data?.resCode === 200) {
                toastSuccess("OTP sent to your email");

            } else {
                toastError(res.data?.message || "Invalid password");
            }
        } catch (err) {
            toastError("Failed to send OTP");
        } finally {
            setLoading(false);
        }
    };

    // const verifyOtp = async () => {
    //     if (otp.length !== 6) return toastError("Enter 6-digit OTP");
    //     setLoading(true);
    //     try {
    //         const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
    //             method: "user",
    //             submethod: "verifyemail",
    //             email: data.email,
    //             otp,
    //             key: process.env.REACT_APP_KEY,
    //         });
    //         if (res.data?.resCode === 200) {
    //             toastSuccess("OTP verified");
    //             setStep(3);
    //         } else {
    //             toastError(res.data?.message || "Invalid OTP");
    //         }
    //     } catch {
    //         toastError("Verification failed");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const updateName = async () => {
        if (!newName) return toastError("Enter new Name");
        setLoading(true);
        try {
            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "user",
                submethod: "uname",
                username,
                name: newName,
                key: process.env.REACT_APP_KEY,
            });
            if (res.data?.resCode === 200) {
                toastSuccess("Name changed successfully");
                navigate("/dashboard");
            } else {
                toastError(res.data?.error || "Failed to update Name");
            }
        } catch {
            toastError("Server error");
        } finally {
            setLoading(false);
        }
    };

    const customStyles = `
    .ai-auth-container {
        min-height: calc(100vh - 88px);
        background: #f1f5f9;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
    }
    
    .ai-auth-card {
        background: #ffffff;
        border-radius: 20px;
        padding: 40px;
        width: 100%;
        max-width: 480px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(0, 0, 0, 0.05);
    }

    .ai-title { color: #1a2234; text-align: center; font-size: 26px; font-weight: 800; margin-bottom: 8px; }
    .ai-subtitle { color: #64748b; text-align: center; font-size: 14px; margin-bottom: 32px; }

    .ai-step-indicator { display: flex; gap: 8px; margin-bottom: 30px; }
    .ai-step-dot { flex: 1; height: 4px; border-radius: 4px; background: #e2e8f0; }
    .ai-step-dot.active { background: #006fe3; box-shadow: 0 0 10px rgba(0, 111, 227, 0.3); }

    .db-input-wrapper {
      background: rgba(238, 242, 246, 0.5); 
      border-radius: 12px; 
      padding: 16px; 
      border: 1px solid rgba(0, 0, 0, 0.05);
      box-shadow: 1px 15px 15px -10px #bfc9d8;
      display: flex; align-items: center; gap: 12px;
      margin-bottom: 24px;
    }

    .db-input {
      background: transparent !important; border: none !important; outline: none !important; width: 100%; font-weight: 700; color: #000000 !important; font-size: 15px;
    }

    .db-modern-btn {
      background: linear-gradient(135deg, #006fe3, #005bb5);
      color: #fff; border: none; padding: 16px; border-radius: 12px;
      font-weight: 700; width: 100%; font-size: 16px;
      box-shadow: 0 4px 15px rgba(0, 111, 227, 0.3); transition: 0.3s;
    }
    .db-modern-btn.green { background: linear-gradient(135deg, #10b981, #059669); box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3); }
    .db-modern-btn.orange { background: linear-gradient(135deg, #f59e0b, #d97706); box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3); }
    .db-modern-btn:hover { transform: translateY(-2px); }
  `;

    return (
        <>
            <style>{customStyles}</style>
            <div className="body-bg">
                <Sidebar />
                <Header />
                <section className="nftmax-adashboard nftmax-show">
                    <div className="ai-auth-container">
                        <div className="ai-auth-card">
                            <h2 className="ai-title">Update Name</h2>
                            <p className="ai-subtitle">Update your login credentials securely</p>


                            <form onSubmit={sendOtp}>
                                <div className="db-input-wrapper">
                                    <input
                                        type="text"
                                        className="db-input"
                                        value={data?.username}
                                        disabled
                                    />
                                </div>

                                <div className="db-input-wrapper">
                                    <input
                                        type="text"
                                        className="db-input"
                                        value={data?.fromname}
                                        disabled
                                    />
                                </div>

                                <div className="db-input-wrapper">
                                    <input
                                        type="text"
                                        className="db-input"
                                        placeholder="Enter New Name"
                                        value={newName}
                                        onChange={(e) => setNewName(e.target.value)}
                                        required
                                    />
                                </div>

                                <button
                                    className="db-modern-btn green"
                                    onClick={updateName}
                                    disabled={loading}
                                >
                                    {loading ? "Updating..." : "Confirm Update"}
                                </button>
                            </form>

                            <div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}
